import React, { useState } from 'react';
// Videos
import MainVideo from '../../assets/videos/mistress-diva-promo-dominatrix-video-portfolio.mp4';
import MainVideoCompressed from '../../assets/videos/mistress-diva-promo-dominatrix-video-portfolio-compressed.mp4';
// Images
import MainImage from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-wings.webp';
// Constants
import { CompanyName, CONTACT_PAGE_URL } from '../../utils/Constants';
// Components
import BigImageBookNow from '../cta/BigImageBookNow';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';

function HomePageMainContainer() {
  // Resolved during the first render rather than in an effect: the <video> src
  // is committed on mount, so settling this afterwards would start the full-fat
  // download on an iPhone before the effect could swap it out.
  const [isIphone] = useState(
    () => typeof navigator !== 'undefined' && /iPhone/.test(navigator.userAgent)
  );

  const selectedVideoSrc = `${
    isIphone ? MainVideoCompressed : MainVideo
  }#t=0.001`;

  return (
    <main
      role='main'
      className='grid full_shadow_black_invert w-full h-full z-10 pointer-events-none'
    >
      {/* Parallax break */}
      <div className='grid h-screen bg-none pointer-events-none -z-10'></div>

      {/* Video */}
      <section className='w-full h-screen overflow-hidden'>
        <video
          src={selectedVideoSrc}
          autoPlay
          muted
          loop
          playsInline
          disablePictureInPicture
          title='Promotional video of Mistress Diva'
          aria-label='Background promotional video of Mistress Diva'
          poster={MainImage}
          className='w-full h-full object-cover'
        />
      </section>

      {/* Image */}
      <BigImageBookNow />

      <section className='grid pointer-events-auto bg-colour4 gap-y-8 w-full border-solid border-b-2 border-colour7 py-10'>
        {/* Text */}
        <section className='grid justify-center'>
          <div className=''>
            <a
              href={CONTACT_PAGE_URL}
              aria-label={`Book now with ${CompanyName}`}
              className='bg-colour1 rounded-full px-8 w-full text-colour2 font-semibold py-2'
            >
              BOOK NOW
            </a>
          </div>
        </section>
      </section>

      <SocialMediaCtaComponent />
    </main>
  );
}

export default HomePageMainContainer;
